var render, staticRenderFns
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=7da51522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da51522",
  null
  
)

/* custom blocks */
import block0 from "./BarChart.vue?vue&type=custom&index=0&blockType=canvas&ref=barChart"
if (typeof block0 === 'function') block0(component)

export default component.exports